import { Box, styled } from '@mui/material';

interface TopRightBoxProps {
  important?: boolean;
}

export const TopRightEditImportantBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'important'
})<TopRightBoxProps>(({ important }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  display: 'flex',
  gap: 8,
  paddingRight: important ? 0 : 8,
  paddingTop: important ? 0 : 8
}));
